import { BaseEdge, getBezierPath } from '@xyflow/react';

/*
 * THE COLOURS HERE ARE `var()` STRINGS AND NEED NO JAVASCRIPT AT ALL.
 *
 * React assigns them straight onto the element's inline style, the browser resolves them against
 * theme.css, and it re-resolves them the instant `data-theme` flips on <html> — no subscription, no
 * re-render, no runtime read. That is also why these three stay PURE functions: the tests that pin
 * them cost nothing because there is no state to set up.
 *
 * These two tokens, not `--xy-edge-stroke`, are what an arrow on screen is made of. Five of the six
 * canvases pass `edgeTypes`, so their edges are BhFlowEdge below, and an inline `style` beats every
 * stylesheet — `!important` included. Setting the vendor variable re-themes only the free-form
 * playground canvas.
 */
export function edgeStrokeStyle(selected) {
  return selected
    ? { stroke: 'var(--bh-edge-selected)', strokeWidth: 1.5 }
    : { stroke: 'var(--bh-edge)', strokeWidth: 1 };
}

export function bhMarkerEnd(selected) {
  return `url(#${selected ? 'bh-edge-arrow-selected' : 'bh-edge-arrow'})`;
}

export function BhEdgeMarkers() {
  const markers = [
    { id: 'bh-edge-arrow', color: 'var(--bh-edge)' },
    { id: 'bh-edge-arrow-selected', color: 'var(--bh-edge-selected)' },
  ];
  return (
    <svg style={{ position: 'absolute', width: 0, height: 0 }} aria-hidden="true">
      <defs>
        {markers.map(m => (
          <marker key={m.id} id={m.id} markerWidth="11.2" markerHeight="5.6" viewBox="0 0 16 8"
            orient="auto" refX="16" refY="4" markerUnits="userSpaceOnUse">
            {/* `style`, NOT the `fill` presentation attribute. Both repaint live on a theme flip in
                Chrome, but var() inside a presentation attribute is unsupported on ios_saf 11, which
                `npx browserslist` still resolves for production — where the failure is a BLACK
                arrowhead, on the one platform nobody here tests. An inline style is var()-safe from
                Safari 9.1, and it also outranks a zero-specificity presentation attribute should
                vendor CSS ever set `path { fill: … }`. */}
            <path d="M0,0 L16,4 L0,8 Z" style={{ fill: m.color }} />
          </marker>
        ))}
      </defs>
    </svg>
  );
}

export default function BhFlowEdge({
  sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition, selected, data, label,
}) {
  const [path, labelX, labelY] = getBezierPath({
    sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
  });
  return (
    <BaseEdge
      path={path}
      label={label}
      labelX={labelX}
      labelY={labelY}
      markerEnd={bhMarkerEnd(selected)}
      style={edgeStrokeStyle(selected)}
      labelStyle={{ fill: selected ? 'var(--bh-edge-selected)' : 'var(--bh-edge)' }}
    />
  );
}
